import React, { useState } from 'react';
import { Box, Grid, TextField, Button } from '@mui/material';

import PartnerModalConatiner from '../../../containers/common/form/modal/PartnerModalConatiner';
import TextMaskPhone from '../../common/form/TextMaskPhone';
import BaseCodeSelectbox from '../../common/form/selectbox/BaseCodeSelectbox';

const TechCustForm = ({ formik }) => {
  const [openParnter, setOpenParnter] = useState(false);
  const handleOpen = () => {
    setOpenParnter(true);
  };
  const handleClose = () => {
    setOpenParnter(false);
  };

  const selectedPartner = (partner) => {
    formik.setFieldValue('custNm', partner.partnerNm);
    formik.setFieldValue('custAddr', partner.partnerAddr);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={6}>
          <TextField
            margin="normal"
            required={true}
            variant="outlined"
            fullWidth
            id="custNm"
            name="custNm"
            label="고객명"
            value={formik.values.custNm}
            onChange={formik.handleChange}
            error={formik.touched.custNm && Boolean(formik.errors.custNm)}
            helperText={formik.touched.custNm && formik.errors.custNm}
          />
        </Grid>
        <Grid item xs={4}>
          <BaseCodeSelectbox
            formik={formik}
            filterObject={{
              blcCd: 'BASE',
              mlcCd: 'TECH',
              slcCd: 'SIGN_STATUS',
              useYn: 'Y',
            }}
            name="signStatus"
            value={formik.values.signStatus}
            margin="normal"
            required={false}
            variant="outlined"
            fullWidth
          />
        </Grid>
        <Grid item xs={2}>
          <Button color="secondary" variant="outlined" onClick={handleOpen}>
            고객 찾기
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            required={false}
            variant="outlined"
            fullWidth
            id="custAddr"
            name="custAddr"
            label="사업장 소재지(주소)"
            value={formik.values.custAddr}
            onChange={formik.handleChange}
            error={formik.touched.custAddr && Boolean(formik.errors.custAddr)}
            helperText={formik.touched.custAddr && formik.errors.custAddr}
          />
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={4}>
          <TextField
            margin="normal"
            required={true}
            variant="outlined"
            fullWidth
            id="custEmpNm"
            name="custEmpNm"
            label="담당자명"
            value={formik.values.custEmpNm}
            onChange={formik.handleChange}
            error={formik.touched.custEmpNm && Boolean(formik.errors.custEmpNm)}
            helperText={formik.touched.custEmpNm && formik.errors.custEmpNm}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            margin="normal"
            required={false}
            variant="outlined"
            fullWidth
            id="custTel"
            name="custTel"
            label="담당자 휴대폰"
            value={formik.values.custTel}
            onChange={formik.handleChange}
            error={formik.touched.custTel && Boolean(formik.errors.custTel)}
            helperText={formik.touched.custTel && formik.errors.custTel}
            InputProps={{
              inputComponent: TextMaskPhone,
            }}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            margin="normal"
            required={false}
            variant="outlined"
            fullWidth
            id="custEml"
            name="custEml"
            label="담당자 Email"
            value={formik.values.custEml}
            onChange={formik.handleChange}
            error={formik.touched.custEml && Boolean(formik.errors.custEml)}
            helperText={formik.touched.custEml && formik.errors.custEml}
          />
        </Grid>
      </Grid>
      <PartnerModalConatiner
        title="고객 찾기"
        open={openParnter}
        handleClose={handleClose}
        selectedPartner={selectedPartner}
      />
    </Box>
  );
};

export default TechCustForm;
